import { Component, Input, OnInit } from '@angular/core';
import { Group, MicrosoftAuthenticatorFeatureSettings } from '@microsoft/microsoft-graph-types-beta';

const featureValues = {
    default: 'Microsoft managed',
    enabled: 'Enabled',
    disabled: 'Disabled',
};
@Component({
    selector: 'app-microsoft-authentication-feature-setting-item',
    templateUrl: './microsoft-authentication-feature-setting-item.component.html',
    styleUrls: [
        './microsoft-authentication-feature-setting-item.component.scss',
        '../../../styles/baseline-style.scss',
    ],
})
export class MicrosoftAuthenticationFeatureSettingItemComponent implements OnInit {
    @Input() groups: Map<string, Group>;
    @Input() graphGroups: Group[];
    @Input() form;
    @Input() featureSettings: MicrosoftAuthenticatorFeatureSettings;
    @Input() item: string;
    @Input() title: string;
    @Input() hint: string;
    @Input() errorsString: string;
    featureValues = featureValues;

    ngOnInit(): void {}
}
